import icsReducer from './reducers';
import * as icsActions from './actions';

export default icsReducer;

export { icsActions };
